export default __webpack_public_path__ + "static/media/beauty-and-wellness.7548a719.png";